/* eslint-disable max-len */
import { BlockWithActionButtonComponent } from './BlockWithActionButtonComponent';
// import { tag } from '../../utils/tag';

// const textTags = (str) => {
//     const textEl = tag('span', 'monospace-print__text', str);
//     const setEl = tag(
//         'span',
//         'monospace-print__ch-set',
//         str
//             .split('')
//             .map((ch, i) => `<span class="ch" style="animation-delay: ${0.1 + i * 0.04}s; transition-delay: ${0.1 + i * 0.04}s;">${ch}</span>`)
//             .join('')
//     );

//     return [textEl, setEl];
// };

export class ResultComp extends BlockWithActionButtonComponent {
    #rootEl;
    #scoreEl;
    #textEl;
    #type;

    constructor(elem) {
        super(elem);

        this.#scoreEl = elem.querySelector('.result__score-value');
        this.#textEl = elem.querySelector('.result__text');
        this.#rootEl = elem;
    }

    update({ score, id: type, text }) {
        if (this.#scoreEl) this.#scoreEl.innerText = score.toString();
        // if (this.#textEl) this.#textEl.innerHTML = textTags(text).map((el) => el.outerHTML).join('');
        if (this.#textEl) this.#textEl.innerHTML = text;

        this.#rootEl.classList.add(`result--${type}`);
        this.#type = type;
    }

    _hidden() {
        super._hidden();

        if (this.#scoreEl) this.#scoreEl.innerText = '';
        if (this.#textEl) this.#textEl.innerHTML = '';
        this.#rootEl.classList.remove(`result--${this.#type}`);
    }
}
